import { getStore } from "../store/lightRPStore";

export default function getIsLightRPOn(): boolean {
    return getStore().isLightRPOn;
}
